import Vue from 'vue';
import Vuex from 'vuex';
/* eslint-disable */
import storeConfig from './storeConfig';

Vue.use(Vuex);

export default new Vuex.Store(storeConfig);
